import { NameModel } from './name.model';

export class ImpersonatorModel {
    id: string;
    type: string;
    name: NameModel;
}